import type { User } from '@/types/site';

export const transformUserToManager = (user: User): User => {
  return {
    id: user.id,
    loginId: user.loginId,
    name: user.name,
    email: user.email || '',
    fullAddress: user.fullAddress || user.cityAddress || '',
    cityAddress: user.cityAddress || '',
    mobilePhone: user.mobilePhone || '',
    phone: user.phone || '',
    userLevel: user.userLevel,
    smsReceive: user.smsReceive,
    siteIds: user.siteIds,
    createdTimestamp: user.createdTimestamp,
    editedTimestamp: user.editedTimestamp,
    description: user.description || '',
  };
};
